module.exports = "<div id=\"<%= property.id %>\" name=\"<%= property.id %>\" class=\"validate[minCheckbox[1]] input checkbox listed searchable <%= property.id %>\" data-prompt-position=\"topRight\">\r\n\t<label for=\"<%= property.id %>\"><%= property.get('description') %></label>\r\n\t<div class=\"checkboxGroup actionsCheckbox\">\r\n\t</div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/report/templates/edit_report_saved_view/multiselect_view.template
// module id = 541
// module chunks = 51